import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données d'une action 'Envoi de SMS'.
 */
export class SendSmsActionData extends BaseActionData {
    /**
     * id du modèle de SMS à utiliser.
     */
    public templateId: number;

    /**
     * valeur indiquant si le SMS ne doit pas être envoyé lorsqu'un destinataire est manquant.
     */
    public dontSendIfRecipientMissing: boolean;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.SendSms);
    }

    /**
     * Retourne une copie d'une instance de SendMailActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: SendSmsActionData) {
        if (!!other) {
            const instance = new SendSmsActionData();
            instance.templateId = other.templateId;
            instance.dontSendIfRecipientMissing = other.dontSendIfRecipientMissing;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
